import { DEFAULT_TAB_OPTIONS, USER_SETTINGS_CNAMES, CBOOL_TRUE, CBOOL_FALSE, ItemViewMode } from '@/constants'
import { LocalStorage } from 'quasar'
import { computed, reactive, ref, toRefs, watch } from 'vue'
import { Store } from 'vuex'

export default function useDeviceSettings ($store: Store<any>) {
  const userSettings = computed(() => $store.getters['User/Settings'])
  const state = computed(() => ({
    hideOperationalDashboard: userSettings.value.hideOperationalDashboard || null,
    defaultTab: DEFAULT_TAB_OPTIONS.find(option => option.value === userSettings.value.defaultTab) || null,
    darkModeEnabled: userSettings.value.darkModeEnabled || null,
    hideResolved: userSettings.value.hideResolved || null,
    newFirst: userSettings.value.newFirst || null,
    orderViewMode: userSettings.value.orderViewMode || null,
    orderAutoAdvance: userSettings.value.orderAutoAdvance || null,
    showNewAsPickable: userSettings.value.showNewAsPickable || null,
    showNewAsPackable: userSettings.value.showNewAsPackable || null,

    packFilterCatalogues: userSettings.value.packFilterCatalogues || [],
    packFilterTags: userSettings.value.packFilterTags || [],

    supplierCatalogueLastViewedTimestamps: userSettings.value.supplierCatalogueLastViewedTimestamps || {}
  }))

  return {
    userSettings,
    state: toRefs(state),
    settings: userSettings,
    options: {
      orderTab: DEFAULT_TAB_OPTIONS,
      orderView: Object.values(ItemViewMode).filter(f => typeof f === 'string').map(k => ({ label: k, value: ItemViewMode[k] }))
    },
    set: (key, value) => {
      LocalStorage.set(USER_SETTINGS_CNAMES[key], typeof value === 'boolean' ? (value ? CBOOL_TRUE : CBOOL_FALSE) : typeof value === 'object' && value.value ? value.value : value)
      void $store.dispatch('User/UpdateSetting', { key, value: typeof value === 'object' && value.value ? value.value : value })
    }
  }
}
